import ModalDeleteProject from './ModalDeleteProject';

export default ModalDeleteProject;
